export default __webpack_public_path__ + "static/media/Phone-contact.20d407ed.svg";